var _rect, _circle, _circle2, _circle3, _path, _path2, _rect2, _path3, _polygon, _polygon2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13.3,
    style: {
      fill: "#000"
    },
    width: 20.4,
    height: 1.8
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13.3,
    width: 20.4,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.8,
    cy: 15.3,
    r: 1.3
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 15.3,
    r: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.8,
    cy: 15.3,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 7.1,
    cy: 15.3,
    r: 1.3
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 15.3,
    r: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 7.1,
    cy: 15.3,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 3.9,
    cy: 15.3,
    r: 1.3
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.9,
    cy: 15.3,
    r: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 3.9,
    cy: 15.3,
    r: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,11.4v4h-2.3v-0.7c0-0.7-0.6-1.3-1.3-1.3h-2.5V9h5.2L22.8,11.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 9,
    style: {
      fill: "#000"
    },
    width: 0.1,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 9.4,
    style: {
      fill: "#000"
    },
    width: 1.5,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "19.5,9.4 19.5,11.4 22.1,11.4 21.5,9.4  "
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,8.4c0.3,0,0.5,0.2,0.6,0.4l0,0.1h-5.2V8.4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 7.3,
    width: 15,
    height: 6
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.9,11.9h-0.7c-0.1,0-0.2,0.1-0.2,0.2l0,0c0,0.1,0.1,0.2,0.2,0.2h0.7c0.1,0,0.2-0.1,0.2-0.2l0,0 C21.1,12,21,11.9,20.9,11.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7,14.1h-1.8v1.5h0.8c0.7,0,1.2-0.5,1.2-1.2l0,0C23,14.2,22.9,14.1,22.7,14.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 13.6,
    style: {
      fill: "#000"
    },
    width: 3.7,
    height: 1.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.7,13.6 13.7,14.1 13.7,14.8 13.7,15.3 14,15.3 14,14.8 14,14.1 14,13.6  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.9,13.6 15.9,14.1 15.9,14.8 15.9,15.3 16.2,15.3 16.2,14.8 16.2,14.1 16.2,13.6  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,12.5v1.2h-0.5c-0.2,0-0.4-0.2-0.4-0.4v-0.9C21.9,12.5,22.8,12.5,22.8,12.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.f89ed22b1b66878b3d6b7fe92f18b965.svg";
export { ForwardRef as ReactComponent };